// extracted by mini-css-extract-plugin
module.exports = {"jcGrey800":"#202d38","login-container":"login-container"};